// Module
var code = "<div class=\"qp-msg-tooltip-more-container\"> <span>{{qpMsgTipDsc || qpMsgTipTitle}} <a ng-href=\"{{qpMsgUrl}}\">{{\"QP-MSG-RETURN-LINK-TEXT\"|translate}}</a> {{(\"QP-MSG-RETURN-SETUP-TEXT\"|translate)}}</span> </div>";
// Exports
export default code;